export const getSpeechRecognitionConstructor = ():
  | typeof SpeechRecognition
  | undefined => window.SpeechRecognition ?? window.webkitSpeechRecognition;

export const isSpeechRecognitionSupported = (): boolean =>
  getSpeechRecognitionConstructor() != null;

export const getSpeechRecognitionIfSupported = (): SpeechRecognition | null => {
  const SpeechRecognitionConstructor = getSpeechRecognitionConstructor();

  if (!SpeechRecognitionConstructor) {
    return null;
  }

  return new SpeechRecognitionConstructor();
};

declare global {
  interface Window {
    SpeechRecognition?: typeof SpeechRecognition;
    webkitSpeechRecognition?: typeof webkitSpeechRecognition;
  }
}
